const KNOWLEDGE_BASE = {
  MAIN_TITLE: 'پایگاه دانش',
  SUB_TITLE: 'مشتریانتان را به پشتیبانی سلف‌سرویس دعوت کنید.',
  COLOR_TITLE: 'رنگ اصلی پایگاه دانش خود را انتخاب کنید.',
  KNOWLEDGE_BASE_TITLE: 'عنوان پایگاه دانش',
  KNOWLEDGE_BASE_TITLE_PLACEHOLDER: 'پایگاه دانش شما',
  DESCRIPTION: 'توضیحات',
  DESCRIPTION_PLACEHOLDER: 'توضیحات را وارد نمایید',
  DOMAIN_NAME: 'نام دامنه',
  DOMAIN_NAME_PLACEHOLDER: 'نام دامنه را وارد نمایید',
  WEBSITE_LINK: 'آدرس وبسایت',
  WEBSITE_LINK_PLACEHOLDER: 'آدرس وبسایت خود را وارد نمایید',
  SCRIPT_TITLE: 'کدهای HTML و اسکریپت',
  CUSTOMIZATION_TITLE: 'شخصی سازی متون',
  PAGE_TITLE: 'عنوان سر صفحه',
  PAGE_TITLE_PLACEHOLDER: 'عنوان سر صفحه را وارد نمایید',
  SEARCH_TEXT: 'متن جستجو',
  SEARCH_PLACEHOLDER: 'متن جستجو را وارد نمایید',
  BUTTON: 'ذخیره',
  ERROR_MESSAGE: 'پر کردن تمامی فیلدها الزامی می‌باشد!',
  COLOR_ERROR_MESSAGE: 'انتخاب رنگ پایگاه دانش ضروری می‌باشد!',
  LOGO_ERROR_MESSAGE: 'انتخاب لوگو پایگاه دانش ضروری می‌باشد!',
  TITLE_ERROR_MESSAGE: 'نوشتن عنوان پایگاه دانش ضروری می‌باشد!',
  DESC_ERROR_MESSAGE: 'نوشتن توضیحات پایگاه دانش ضروری می‌باشد!',
  DOMAIN_ERROR_MESSAGE: 'نوشتن نام دامنه پایگاه دانش ضروری می‌باشد!',
  LINK_ERROR_MESSAGE:
    'اضافه کردن لینک پایگاه دانش (به همراه //:https) ضروری می‌باشد!',
  UN_VALID_LINK: 'لینک پایگاه دانش خود را به درستی وارد کنید!',
  PAGE_TITLE_ERROR_MESSAGE: 'نوشتن عنوان سر صفحه پایگاه دانش ضروری می‌باشد!',
  SEARCH_TEXT_ERROR_MESSAGE: 'نوشتن متن جستجو پایگاه دانش ضروری می‌باشد!',
  SUCCESSFUL_MESSAGE: 'اطلاعات با موفقیت ذخیره شد!',
  KNOWLEDGE_BASE_LOGO: 'لوگو پایگاه دانش',
  KNOWLEDGE_BASE_LOGO_PLACEHOLDER: 'آپلود تصویر',
  KNOWLEDGE_BASE_DOWNLOAD_BTN: 'دانلود فایل نصب',
  PHOTO_UPLOAD_RECOMMENDATION:
    'ابعاد پیشنهادی لوگو 55*55 پیکسل و در فرمت png باشد.',
  YOUR_KNOWLEDGE_BASE_LINK: 'لینک پایگاه دانش شما',
};

export default KNOWLEDGE_BASE;
